import {orderBy, groupBy, flattenDeep, map, uniq} from 'lodash'

export const getDealEmails = ({ all }) => orderBy(all, ['created_at'], ['desc'])

export const getEmailAddresses = ({ all }, getters, dealObj) => {
    let to = map(Object.getOwnPropertyNames(groupBy(all, 'to')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let cc = map(Object.getOwnPropertyNames(groupBy(all, 'cc')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let bcc = map(Object.getOwnPropertyNames(groupBy(all, 'bcc')), (address) => (address !== 'null') ? address.toLowerCase().split(',') : '')
    let allAddresses = flattenDeep([to, cc, bcc])

    let addresses = []
    for (let address of uniq(allAddresses))
        if (address !== dealObj.lead.info.email && address !== getters.getMember.email && address !== '')
            addresses.push({'id': address, 'name': address})

    return addresses
}



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/emails/store/getters.js